import type { PlayCircleRelationshipDto } from '@/lib/play/playCircleReadService'

export type PlayCircleOrbitDensity = 'empty' | 'one' | 'four' | 'many'

export type PlayCircleOrbitFriend = {
  id: string
  name: string
  photoUrl?: string | null
}

export function mapCircleRelationshipsToOrbitFriends(
  relationships: PlayCircleRelationshipDto[]
): PlayCircleOrbitFriend[] {
  return relationships.map((rel) => ({
    id: rel.friendDog.id,
    name: rel.friendDog.name,
    photoUrl: rel.friendDog.photoUrl,
  }))
}

export function circleCountToOrbitDensity(count: number): PlayCircleOrbitDensity {
  if (count <= 0) return 'empty'
  if (count === 1) return 'one'
  if (count <= 4) return 'four'
  return 'many'
}
